import utils from '@/utils';

export const routes = [
    {
        name: 'Login',
        path: '/login',
        meta: {
            requiresAuth: false,
            keepAlive: false,
            layout: '',
        },
        // eslint-disable-next-line no-unused-vars
        beforeEnter: (to, from, next) => {
            const {
                params: { returnUrl = '' },
            } = to;
            const loginUrl = utils.loginUrl(returnUrl);
            window.location.replace(loginUrl);
        },
        component: () => import('@views/home/PortalHome'),
    },
    {
        name: 'Unauthorized',
        path: '/unauthorized',
        meta: {
            requiresAuth: false,
            keepAlive: false,
            layout: 'public',
        },
        component: () => import('@components/users/views/UnauthorizedRequest'),
    },
    {
        name: 'Portal Home',
        path: '/',
        meta: {
            requiresAuth: true,
            keepAlive: true,
            layout: 'auth', // specify layout for route here, we require an authorized layout for this route
        },
        component: () => import('@views/home/PortalHome'),
    },
    {
        name: 'Order History',
        path: '/orders/history',
        meta: {
            requiresAuth: true,
            keepAlive: true,
            layout: 'auth', // specify layout for route here, we require an authorized layout for this route
        },
        component: () => import('@views/screens/ScreeningHistory'),
    },
    {
        name: 'Order Search',
        path: '/orders/search/',
        meta: {
            requiresAuth: true,
            keepAlive: true,
            layout: 'auth', // required, authorized layout
        },
        component: () => import('@views/applications/ApplicationSearch'),
    },
    {
        name: 'Register',
        path: '/register',
        meta: {
            requiresAuth: false,
            keepAlive: false,
            layout: 'public',
        },
        component: () => import('@views/registration/RegisterUser'),
    },
    {
        name: 'Register Error',
        path: '/register/error',
        meta: {
            requiresAuth: false,
            keepAlive: false,
            layout: 'public',
        },
        component: () => import('@views/registration/RegisterError'),
    },
    {
        name: 'Order Print',
        path: '/orders/print/:id',
        meta: {
            requiresAuth: false,
            keepAlive: false,
            layout: 'print', // print layout to print the Applicant PDF
        },
        component: () => import('@views/screens/OrderPrint'),
    },
    {
        name: 'Application Process',
        path: '/orders/process/:id',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth',
        },
        component: () => import('@views/screens/ScreeningProcess'),
    },
    {
        name: 'Applicant Print',
        path: '/applicant/print/:id',
        meta: {
            requiresAuth: false,
            keepAlive: false,
            layout: 'print', // print layout to print the Applicant PDF
        },
        component: () => import('@views/screens/ApplicantPrint'),
    },
    {
        name: 'Application Print',
        path: '/application/print/:id',
        meta: {
            requiresAuth: false,
            keepAlive: false,
            layout: 'print', // print layout to print the Applicant PDF
        },
        component: () => import('@views/screens/ApplicationPrint'),
    },
    {
        path: '/account',
        redirect: '/acccount/dashboard',
    },
    {
        path: '/account/',
        component: () => import('@views/account/MyAccount.vue'),
        meta: {
            requiresAuth: true,
            keepAlive: true,
            layout: 'auth',
        },
        children: [
            {
                name: 'Account Dashboard',
                path: 'dashboard',
                meta: {
                    requiresAuth: true,
                    keepAlive: false,
                    layout: 'auth', // specify layout for route here, we require an authorized layout for this route
                },
                component: () =>
                    import('@components/account/components/AccountDashboard'),
            },
            {
                name: 'Account Company',
                path: 'company',
                meta: {
                    requiresAuth: true,
                    keepAlive: false,
                    layout: 'auth', // specify layout for route here, we require an authorized layout for this route
                },
                component: () =>
                    import('@components/account/components/AccountCompany'),
            },
            {
                name: 'Account Properties',
                path: 'properties',
                meta: {
                    requiresAuth: true,
                    keepAlive: false,
                    layout: 'auth', // specify layout for route here, we require an authorized layout for this route
                },
                component: () =>
                    import('@components/account/components/AccountProperties'),
            },
            {
                name: 'Account Teams',
                path: 'teams',
                meta: {
                    requiresAuth: true,
                    keepAlive: false,
                    layout: 'auth', // specify layout for route here, we require an authorized layout for this route
                },
                component: () =>
                    import('@components/account/components/AccountTeams'),
            },
            {
                name: 'Account Users',
                path: 'users',
                meta: {
                    requiresAuth: true,
                    keepAlive: false,
                    layout: 'auth', // specify layout for route here, we require an authorized layout for this route
                },
                component: () =>
                    import('@components/account/components/AccountUsers'),
            },
            {
                name: 'Account Profile',
                path: 'profile',
                meta: {
                    requiresAuth: true,
                    keepAlive: false,
                    layout: 'auth', // specify layout for route here, we require an authorized layout for this route
                },
                component: () =>
                    import('@components/account/components/AccountProfile'),
            },
            {
                name: 'Account Billing',
                path: 'billing',
                meta: {
                    requiresAuth: true,
                    keepAlive: false,
                    layout: 'auth', // specify layout for route here, we require an authorized layout for this route
                },
                component: () =>
                    import('@components/account/components/AccountBilling'),
            },
            {
                name: 'Account Reports',
                path: 'reports',
                meta: {
                    requiresAuth: true,
                    keepAlive: false,
                    layout: 'auth', // specify layout for route here, we require an authorized layout for this route
                },
                component: () =>
                    import('@components/account/components/AccountReports'),
            },
        ],
    },
    {
        name: 'Program Dashboard',
        path: '/programs/dashboard',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth', // specify layout for route here, we require an authorized layout for this route
        },
        component: () => import('@components/program/views/ProgramDashboard'),
    },
    {
        name: 'Program Instructors',
        path: '/programs/instructors',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth', // specify layout for route here, we require an authorized layout for this route
        },
        component: () => import('@components/program/views/ProgramInstructors'),
    },
    {
        name: 'Program Students',
        path: '/programs/students',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth', // specify layout for route here, we require an authorized layout for this route
        },
        component: () => import('@components/program/views/ProgramStudents'),
    },

    {
        name: 'Program Edit',
        path: '/programs/edit/:id?',
        meta: {
            requiresAuth: true,
            keepAlive: true,
            layout: 'auth', // specify layout for route here, we require an authorized layout for this route
        },
        component: () => import('@components/program/views/ProgramEdit'),
    },
    {
        name: 'Instructor Dashboard',
        path: '/programs/instructor/dashboard',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth', // specify layout for route here, we require an authorized layout for this route
        },
        component: () =>
            import('@components/program/views/InstructorDashboard'),
    },
    {
        name: 'Student Dashboard',
        path: '/programs/student/dashboard/:id?',
        meta: {
            requiresAuth: true,
            keepAlive: true,
            layout: 'auth', // required, authorized layout
        },
        component: () => import('@components/program/views/StudentDashboard'),
    },
    {
        name: 'Admin Companies',
        path: '/admin/companies',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth',
        },
        component: () => import('@views/admin/AdminCompanies'),
    },
    {
        name: 'Settings Colors',
        path: '/settings/colors/',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth',
        },
        component: () => import('@views/settings/SettingsColors'),
    },
    {
        name: 'Settings Logos',
        path: '/settings/logos/',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth',
        },
        component: () => import('@views/settings/SettingsLogos'),
    },
    {
        name: 'New Application',
        path: '/applications/create/',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth',
        },
        component: () => import('@views/screens/ScreeningNewApplication'),
    },
    {
        name: 'Invoicing',
        path: '/invoicing/',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth',
        },
        component: () => import('@views/invoices/CompanyInvoicing'),
    },
    {
        name: 'Invoice',
        path: '/invoice/:id',
        meta: {
            requiresAuth: true,
            keepAlive: false,
            layout: 'auth',
        },
        component: () => import('@views/invoices/PropertyInvoice'),
    },
    {
        name: 'Print Invoice',
        path: '/invoice/print/:id',
        meta: {
            requiresAuth: false,
            keepAlive: false,
            layout: 'print',
        },
        component: () => import('@views/invoices/InvoicePrint'),
    },
    {
        name: 'Blank Page',
        path: '/blank',
        meta: {
            requiresAuth: false,
            keepAlive: false,
            layout: 'public',
        },
        component: () => import('@views/blank/BlankPage'),
    },
];
